const API_V1 = '/api/v1';

export const endpoints = {
  health: '/health',
  products: `${API_V1}/products`,
  productById: (productId: string) => `${API_V1}/products/${productId}`,
  users: `${API_V1}/users`,
  userMe: `${API_V1}/users/me`,
  userById: (userId: string) => `${API_V1}/users/${userId}`,
  usersInvite: `${API_V1}/users/invite`,
  userRoles: (userId: string) => `${API_V1}/users/${userId}/roles`,
  userGroups: (userId: string) => `${API_V1}/users/${userId}/groups`,
  userProducts: (userId: string) => `${API_V1}/users/${userId}/products`,
  userDepartments: `${API_V1}/users/departments`,
  userRolesCatalog: `${API_V1}/users/roles`,
  iamRoles: `${API_V1}/iam/roles`,
  iamGroups: `${API_V1}/iam/groups`,
  iamPermissions: `${API_V1}/iam/permissions`,
  groups: `${API_V1}/groups`,
  groupById: (groupId: string) => `${API_V1}/groups/${groupId}`,
  groupMembers: (groupId: string) => `${API_V1}/groups/${groupId}/members`,
  groupRoles: (groupId: string) => `${API_V1}/groups/${groupId}/roles`,
  groupProducts: (groupId: string) => `${API_V1}/groups/${groupId}/products`,
  roles: `${API_V1}/roles`,
  roleById: (roleId: string) => `${API_V1}/roles/${roleId}`,
  rolePermissions: (roleId: string) => `${API_V1}/roles/${roleId}/permissions`,
  rolesClone: `${API_V1}/roles/clone`,
  permissions: `${API_V1}/permissions`,
  audit: `${API_V1}/audit`,
  auditById: (auditId: string) => `${API_V1}/audit/${auditId}`,
  auditExport: `${API_V1}/audit/export`,
  auditActions: `${API_V1}/audit/actions`,
  auditResources: `${API_V1}/audit/resources`,
  auditSeverity: `${API_V1}/audit/severity`,
  systemSettings: `${API_V1}/system/settings`,
  systemSettingsGeneral: `${API_V1}/system/settings/general`,
  systemSettingsSecurity: `${API_V1}/system/settings/security`,
  systemSettingsNotifications: `${API_V1}/system/settings/notifications`,
  systemSettingsBranding: `${API_V1}/system/settings/branding`,
  systemLogo: `${API_V1}/system/logo`,
  systemFavicon: `${API_V1}/system/favicon`,
  featureFlags: `${API_V1}/feature-flags`,
  featureFlagById: (featureFlagId: string) =>
    `${API_V1}/feature-flags/${featureFlagId}`,
  featureFlagRollout: (featureFlagId: string) =>
    `${API_V1}/feature-flags/${featureFlagId}/rollout`,
  featureFlagsEnvironments: `${API_V1}/feature-flags/environments`,
  featureFlagsProducts: `${API_V1}/feature-flags/products`,
  menus: (productId: string) => `${API_V1}/products/${productId}/menus`,
  menuById: (productId: string, menuItemId: string) =>
    `${API_V1}/products/${productId}/menus/${menuItemId}`,
} as const;
